import * as yup from 'yup';
import { stringReqSchema } from '../../../utils';

const rules = yup.object({
  contactPersonName: stringReqSchema('Name'),
  companyName: stringReqSchema('Company'),
  country: stringReqSchema('Country'),
  city: stringReqSchema('City'),
  phoneNumber: stringReqSchema('Phone Number'),
  email: stringReqSchema('Email'),
  websiteUrl: stringReqSchema('Website'),
});

export default rules;
